const LCFS = {
    california: {
        2021: {
            diesel: 91.660625,
            gasoline: 90.739,
        },
        2022: {
            diesel: 90.405,
            gasoline: 89.496,
        },
        2023: {
            diesel: 89.149375,
            gasoline: 88.253,
        },
        2024: {
            diesel: 87.89375,
            gasoline: 87.01,
        },
        2025: {
            diesel: 86.638125,
            gasoline: 85.767,
        },
        2026: {
            diesel: 85.3825,
            gasoline: 84.524,
        },
        2027: {
            diesel: 84.126875,
            gasoline: 83.281,
        },
        2028: {
            diesel: 82.87125,
            gasoline: 82.038,
        },
        2029: {
            diesel: 81.615625,
            gasoline: 80.795,
        },
        2030: {
            diesel: 80.36,
            gasoline: 79.552,
        },
    },
};
const dieselEER = 5.0;
const gasolineEER = 3.4;
const energyDensity = 3.6;
const gridIntensity = 82.92;
const EER_VALUES = {
    gasoline: gasolineEER,
    diesel: dieselEER,
};
const DIESEL_EMISSIONS_IN_LBS_PER_GAL = 22.38; // http://www.patagoniaalliance.org/wp-content/uploads/2014/08/How-much-carbon-dioxide-is-produced-by-burning-gasoline-and-diesel-fuel-FAQ-U.S.-Energy-Information-Administration-EIA.pdf
const GASOLINE_EMISSIONS_IN_LBS_PER_GAL = 19.64; // http://www.patagoniaalliance.org/wp-content/uploads/2014/08/How-much-carbon-dioxide-is-produced-by-burning-gasoline-and-diesel-fuel-FAQ-U.S.-Energy-Information-Administration-EIA.pdf
const BRIGHTDROP_DIESEL_EMISSIONS_IN_LBS_PER_GAL = 22.45;
const BRIGHTDROP_GASOLINE_EMISSIONS_IN_LBS_PER_GAL = 17.86;
const YEAR = 2023;
export { LCFS, dieselEER, gasolineEER, energyDensity, gridIntensity, DIESEL_EMISSIONS_IN_LBS_PER_GAL, GASOLINE_EMISSIONS_IN_LBS_PER_GAL, BRIGHTDROP_DIESEL_EMISSIONS_IN_LBS_PER_GAL, BRIGHTDROP_GASOLINE_EMISSIONS_IN_LBS_PER_GAL, YEAR, EER_VALUES, };
